import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-notification-counter',
  templateUrl: './notification-counter.component.html',
  styleUrls: ['./notification-counter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NotificationCounterComponent {
  @Input() count: number = 0;
}
